import { Controller } from "@hotwired/stimulus";
import Splide from '@splidejs/splide';
import tinycolor from "tinycolor2";
import { Spinner } from 'spin.js';

// Connects to data-controller="click-games"
let currentPage; // Variável global
let pages;
let movedPage;

export default class extends Controller {
  static targets = [ 
    "mainCarrousel", 
    "thumbnailCarrousel", 
    "description",
    "title",
    "backdrop",
    "header", 
    "footer",
    "nextIcon",
    "nodes",
    "oneNodeContent",
    "changeNodeButton",
    "backdropActions",
    "backdropEnd",
    "nodesPath"
  ]

  static values = {
    apiUrl: {type: String, default: 'https://app.museueducativo.com.br'},
    devApiUrl: {type: String, default: 'http://localhost:4000'},
    clickGame: Object,
    coverUrl: String,
    textColor: String,
    userId: Number,
    clickGameId: Number
  }

  connect() {
    if (this.hasClickGameValue) {
      this.setBackground(this.clickGameValue);
      this.setCarrousel();
      this.setCover(this.clickGameValue);
      this.setWelcomeMessage(this.clickGameValue);
      this.setNextIconColor(this.clickGameValue);
      this.textColorValue = tinycolor(this.clickGameValue.bkg).isLight() ? '#888' : '#fff';
    }
    pages = [];
  }

  setNextIconColor(clickGame) {
    this.nextIconTarget.style.color = clickGame.bkg;
  }

  hideChangeNodeButton() {
    this.changeNodeButtonTarget.classList.remove('d-block');
    this.changeNodeButtonTarget.classList.add('d-none');
  }

  showChangeNodeButton() {
    this.changeNodeButtonTarget.classList.remove('d-none');
    this.changeNodeButtonTarget.classList.add('d-block');
  }

  backdropOn(event) {
    this.nodesTarget.innerHTML = ""
    if (currentPage === undefined) {
      this.newSlide();
    } else if(event.params.revert == true){
      Array.from(currentPage.children).forEach(page => {
        this.addNode(page, true);
      })
      this.backdropJourneyOn();     
    } else if(this.mainCarrousel.length > (this.mainCarrousel.index + 1)){
      this.mainCarrousel.go(this.mainCarrousel.index + 1);
    } else if(currentPage.children.length == 1) {
      currentPage = this.clickGameValue.click_game_works.find(page => page.id == currentPage.children[0].id);
      this.newSlide()
    } else {
      if (currentPage.children.length > 1) {  
        this.backdropJourneyOn();
        Array.from(currentPage.children).forEach(page => {
          this.addNode(page, false);
        })
      } else {
        this.backdropJourneyOff();
        this.journeyEnd();        
      }
    }
  }

  backdropJourneyOn() {
    this.backdropTarget.classList.add('active');  
    this.backdropActionsTarget.classList.remove('d-none')
    this.backdropEndTarget.classList.add('d-none')
  }

  backdropJourneyOff() {
    this.backdropTarget.classList.add('active');  
    this.backdropActionsTarget.classList.add('d-none')
    this.backdropEndTarget.classList.remove('d-none')
  }

  addNode(page, revert) {
    // Verificar o tamanho da tela
    const isSmallScreen = window.innerWidth < 768; // Define "small screen" como <768px

    // Criação da div principal
    const divCol = document.createElement('div');
    divCol.className = isSmallScreen ? 'col-sm-12 node-col tm-0 m-2' : 'col node-col tm-0 m-2';
    divCol.style.backgroundColor = this.clickGameValue.bkg;
    
    const divColContainer = document.createElement('div');
    divColContainer.className = 'container-fluid'

    const divColRow1 = document.createElement('row');
    divColRow1.className = 'row';

    const divCol8 = document.createElement('div');
    divCol8.className = 'col-md-8 col-sm-12'

    const divCol4 = document.createElement('div');
    divCol4.className = 'col-md-4 col-sm-12'

    divColRow1.appendChild(divCol8);
    divColRow1.appendChild(divCol4);

    // Criação do botão
    const button = document.createElement('button');
    button.setAttribute('data-action', 'click->click-games#nextSlide');
    button.id = 'node-' + Date.now() + '-' + Math.floor(Math.random() * 10000);
    button.setAttribute('data-current-page', JSON.stringify(page));
    button.className = 'h-100 btn btn-transparent w-100 d-flex align-items-center justify-content-center arrow-font';
    button.style.color = '#fff';
    button.textContent = page.next_button_text;
    if (revert == true) {
      button.setAttribute('data-click-games-revert-param', true);
    }

    // Criação do ícone
    const icon = document.createElement('i');
    icon.className = 'fa-regular fa-hand-pointer pe-1';
    icon.setAttribute('data-click-games-target', 'nextIcon');

    // Adicionar o ícone ao botão
    button.insertBefore(icon, button.firstChild);
    divCol4.appendChild(button)

    divColContainer.appendChild(divColRow1);
    divCol.appendChild(divColContainer)

    // Criação do elemento h4
    const headingElement = document.createElement('h4');
    headingElement.textContent = page.title;

    // Criação do parágrafo
    // const textElement = document.createElement('p');
    // textElement.textContent = page.description;

    // Adicionar os elementos ao div
    divCol8.appendChild(headingElement);
    // divCol8.appendChild(textElement);

    this.nodesTarget.appendChild(divCol);
  }

  backdropOff() {
    this.backdropTarget.classList.remove("active");
  }
  
  setWelcomeMessage(clickGame) {
    this.descriptionTarget.innerHTML = clickGame.description;
  }

  setCarrousel() {
    this.thumbnailCarrousel = this.setThumbnailCarrousel();
    this.mainCarrousel = this.setMainCarrousel();

    this.mainCarrousel.sync( this.thumbnailCarrousel );
    this.mainCarrousel.mount();
    this.thumbnailCarrousel.mount();

    this.mainCarrousel.on('moved', (newIndex) => {
      this.pageMoving(newIndex);
      this.pauseYouTubeVideos();
    })
  }

  pageMoving(index) {
    if (pages[index - 1]) {
      if ((pages[index - 1].children.length > 1) && ((this.mainCarrousel.length - 1) > index)) {
        this.showChangeNodeButton();
      } else {
        this.hideChangeNodeButton();
      }
      currentPage = pages[index - 1];
      this.setTitleAndDescription(pages[index-1]);
      this.setOneNodeContent(pages[index-1])
    }
  }

  setMainCarrousel() {
    return new Splide( this.mainCarrouselTarget, {
      type      : 'fade',
      rewind    : true,
      pagination: false,
      arrows    : false,
    } );
  }

  setThumbnailCarrousel(){
    return new Splide(this.thumbnailCarrouselTarget, {
      fixedWidth  : 100,
      fixedHeight : 60,
      gap         : 10,
      rewind      : true,
      pagination  : false,
      isNavigation: true,
      arrows      : false,
      classes: {
        arrows: 'splide__arrows click-games-arrows'
      },    
      breakpoints : {
        600: {
          fixedWidth : 60,
          fixedHeight: 44,
        },
      },
    } )
  }

  setBackground(clickGame) {
    this.headerTarget.style.backgroundColor = clickGame.bkg;
    this.footerTarget.style.backgroundColor = clickGame.bkg;
  }

  setCover(clickGame) {
    const imageUrl = this.apiUrlValue + clickGame.cover_url;

    this.thumbnailCarrousel.add(this.newSliderImage(imageUrl, 'Imagem de capa desta trilha do clique'));
    this.mainCarrousel.add(this.newSliderImage(imageUrl, 'Imagem de capa desta trilha do clique'));
  }

  setTitleAndDescription(page) {
    let h1Title = document.createElement( 'h1' );
    h1Title.textContent = page.title;
    
    this.titleTarget.innerHTML = '';
    this.titleTarget.appendChild(h1Title)

    this.descriptionTarget.innerHTML = page.description;
  }

  newSlide(isReverting = false) {
    if (currentPage === undefined) {
      currentPage = this.clickGameValue.click_game_works.filter(cgw =>{ 
        return cgw.parent_id == null;
      })[0]
     
      
      if (currentPage.media_urls.length == 1) {
        if (currentPage.media_urls[0].name == 'images') {
          let page = currentPage;
          let media = page.media_urls[0];

          const imageUrl = this.apiUrlValue + media.url;
    
          this.thumbnailCarrousel.add(this.newSliderImage(imageUrl, page.title));
          this.mainCarrousel.add(this.newSliderImage(imageUrl, page.title));   

          this.setTitleAndDescription(page);
          
          // Ativa o slide adicionado
          const newIndex = this.mainCarrousel.length - 1; // Obtém o índice do slide recém-adicionado
          this.mainCarrousel.go(newIndex); // Vai para o slide adicionado
        }
      }
    } else {
      if (currentPage.media_urls.length == 1) {
        let page = currentPage;
        let media = page.media_urls[0];
        this.setTitleAndDescription(page)

        if (currentPage.media_urls[0].name == 'images') {
          const imageUrl = this.apiUrlValue + media.url;
          this.thumbnailCarrousel.add(this.newSliderImage(imageUrl, page.title));
          this.mainCarrousel.add(this.newSliderImage(imageUrl, page.title));   
        } else if(currentPage.media_urls[0].name == 'videos') {
          const videoUrl = media.youtube_link;
          this.thumbnailCarrousel.add(this.newSliderImage(this.getYouTubeThumbnail(videoUrl), page.title));
          this.mainCarrousel.add(this.newSliderVideo(videoUrl, page.title)); // Agora adiciona o vídeo
        }

        // Ativa o slide adicionado
        const newIndex = this.mainCarrousel.length - 1; // Obtém o índice do slide recém-adicionado
        this.mainCarrousel.go(newIndex); // Vai para o slide adicionado        
        if (isReverting) {
          this.hideChangeNodeButton();
        }
      }
    }

    pages.push(currentPage);
    this.setOneNodeContent(currentPage);
    // console.log(currentPage.title, currentPage)
    // console.log('pages', pages)
    // console.log('pages.lenght', pages.length)
    // console.log('---------------------------')


  }

  pauseYouTubeVideos() {
    // Seleciona todos os iframes de vídeo dentro do mainCarrousel
    const iframes = this.mainCarrouselTarget.querySelectorAll("iframe");
  
    iframes.forEach((iframe) => {
      const src = iframe.src;
      if (src.includes("youtube.com")) {
        iframe.src = ""; // Remove temporariamente o src para parar o vídeo
        iframe.src = src; // Restaura o src para evitar falhas de carregamento
      }
    });
  }
  

  getYouTubeThumbnail(videoUrl) {
    const videoIdMatch = videoUrl.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/|youtube\.com\/shorts\/)([^"&?\/\s]{11})/);
    
    if (videoIdMatch && videoIdMatch[1]) {
      return `https://img.youtube.com/vi/${videoIdMatch[1]}/hqdefault.jpg`; // Retorna a miniatura
    } else {
      return null; // Retorna null se a URL for inválida
    }
  }

  extractYouTubeID(videoUrl) {
    const videoIdMatch = videoUrl.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/|youtube\.com\/shorts\/)([^"&?\/\s]{11})/);
    return videoIdMatch ? videoIdMatch[1] : null;
  }


  newSliderVideo(videoUrl, alt) {
    const slide = document.createElement('li');
    slide.classList.add('splide__slide');
  
    // Criar um container responsivo para o vídeo
    const videoContainer = document.createElement('div');
    videoContainer.style.position = "relative";
    videoContainer.style.width = "100%";
    videoContainer.style.maxHeight = "400px"; // Altura máxima para PC
    videoContainer.style.aspectRatio = "16 / 9"; // Mantém proporção
    videoContainer.style.overflow = "hidden";
    videoContainer.style.display = "flex";
    videoContainer.style.alignItems = "center";
    videoContainer.style.justifyContent = "center";
  
    // Criar o iframe do YouTube
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube.com/embed/${this.extractYouTubeID(videoUrl)}?rel=0&modestbranding=1&showinfo=0&controls=1&autoplay=0`;
    iframe.width = "100%";
    iframe.height = "100%";
    iframe.allowFullscreen = true;
    iframe.style.border = "none";
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "100%";
    iframe.style.height = "100%";
  
    // Adicionar o iframe ao container
    videoContainer.appendChild(iframe);
    slide.appendChild(videoContainer);
  
    return slide;
  }
  

  activeSlideIndex() {
    // Obtém o índice do slide ativo no carrossel principal
    const activeIndex = this.mainCarrousel.index;
    
    // Obtém todos os slides
    const slides = this.mainCarrousel.Components.Elements.slides;
  
    // Obtém o slide ativo
    const activeSlide = slides[activeIndex];
  
    if (activeSlide) {
      return activeIndex;
    } else {
      return undefined;
    }
  }
  
  setOneNodeContent(currentPage) {
    const content = currentPage.children.length == 1 ? currentPage.children[0].next_button_text : "";

    // Criar o elemento <p>
    const paragraph = document.createElement("p");
    paragraph.textContent = content;
    paragraph.classList.add('m-0');
    paragraph.classList.add('p-0');
    
    // Limpar o conteúdo anterior e adicionar o novo elemento
    this.oneNodeContentTarget.innerHTML = ""; // Remove qualquer conteúdo existente
    this.oneNodeContentTarget.appendChild(paragraph);
  }

  revertClean(selectedIndex) {
    // Verifica se os índices são válidos    
    if (selectedIndex < 0 || selectedIndex >= this.mainCarrousel.length) {
      console.warn("Índice inválido. Nenhuma remoção feita.");
      return;
    }
  
    // Remove os slides com índice maior que selectedIndex
    for (let i = this.mainCarrousel.length - 1; i > selectedIndex; i--) {
      this.mainCarrousel.remove(i);
      this.thumbnailCarrousel.remove(i);
    }
    
    for (let i = pages.length - 1; i >= selectedIndex; i--) {
      pages.splice(i, 1);
    }
  }
  
  getYouTubeThumbnail(videoUrl) {
    // Expressão regular para extrair o ID do vídeo do YouTube
    const videoIdMatch = videoUrl.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/|youtube\.com\/shorts\/)([^"&?\/\s]{11})/);
  
    // Verifica se encontrou um ID válido
    if (videoIdMatch && videoIdMatch[1]) {
      const videoId = videoIdMatch[1];
      return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`; // Retorna a thumbnail
    } else {
      return null; // Retorna null se a URL for inválida
    }
  }

  nextSlide(event) {
    if (event.params.revert == true) {
      this.revertClean(this.mainCarrousel.index)
    } 

    const element = event.currentTarget;
    let innerCurrentPage = JSON.parse(element.dataset.currentPage);
    currentPage = this.clickGameValue.click_game_works.filter(page => {
      return page.id == innerCurrentPage.id
    })[0]
      
    this.backdropOff();
    this.newSlide(event.params.revert == true);            
  }

  journeyEnd() {
    this.nodesPathTarget.innerHTML = ""; // Limpa o conteúdo antes de adicionar a trilha
    
    if (this.clickGameValue.post_card_site?.trim()) {
      const journeyPage = this.generatePostCardPage();
      this.nodesPathTarget.appendChild(journeyPage);
      // Está presente e não é só espaço em branco
    } else {
      const journeyPage = this.generateJourneyPage();
      this.nodesPathTarget.appendChild(journeyPage);

    }
  
    // Rola automaticamente para o topo das paradas
    this.nodesPathTarget.scrollTop = 0;
  }
  
  generateJourneyPage() {
    // Criar o container principal
    const journeyContainer = document.createElement("div");
    journeyContainer.classList.add("journey-container");
  
    // Criar o título da página
    const title = document.createElement("h2");
    title.innerHTML = `Sua jornada terminou! <br> <small>Veja o caminho que você percorreu</small>`;
    title.classList.add("journey-title");

    // Criar a linha do tempo
    const timeline = document.createElement("div");
    timeline.classList.add("journey-timeline");
  
    pages.forEach((page, index) => {
      // Criar o elemento de parada na trilha
      const step = document.createElement("div");
      step.classList.add("journey-step");
  
      // Criar a miniatura da parada
      let mediaElement;
      if (page.media_urls.length > 0) {
        const media = page.media_urls[0];
  
        if (media.name === "images") {
          mediaElement = document.createElement("img");
          mediaElement.src = this.apiUrlValue + media.url;
        } else if (media.name === "videos") {
          mediaElement = document.createElement("img");
          mediaElement.src = this.getYouTubeThumbnail(media.youtube_link);
        }
      } else {
        mediaElement = document.createElement("div");
        mediaElement.classList.add("no-media");
        mediaElement.textContent = "Sem mídia";
      }
  
      mediaElement.classList.add("journey-media");
  
      // Criar a descrição da parada
      const stepInfo = document.createElement("div");
      stepInfo.classList.add("journey-info");
  
      const stepTitle = document.createElement("h4");
      stepTitle.textContent = `Parada ${index + 1}: ${page.title}`;
  
      const stepDesc = document.createElement("p");
      stepDesc.innerHTML = page.description || "Descrição não disponível.";

      stepInfo.appendChild(stepTitle);
      stepInfo.appendChild(stepDesc);
  
      step.appendChild(mediaElement);
      step.appendChild(stepInfo);
  
      timeline.appendChild(step);
    });
  
   // Criar o container dos botões
   const buttonContainer = document.createElement("div");
   buttonContainer.classList.add("journey-buttons");
   buttonContainer.classList.add("mt-3");
 
   // Criar um botão para voltar ao jogo
   const backButton = document.createElement("button");
   backButton.classList.add("btn", "btn-outline-light");
   backButton.textContent = "Voltar";
   backButton.addEventListener("click", () => {
     journeyContainer.remove(); // Remove a página de jornada
     this.backdropOff(); // Fecha o backdrop
   });
 
   // Criar o botão para salvar a trilha
   const saveButton = document.createElement("button");
   saveButton.classList.add("btn", "btn-light");
   saveButton.textContent = "Compartilhar";
   saveButton.setAttribute("data-action", "click->click-games#saveClickGame");
 
   // Adicionar os botões ao container
   buttonContainer.appendChild(backButton);
   buttonContainer.appendChild(saveButton);
 
   journeyContainer.appendChild(title);
   journeyContainer.appendChild(timeline);
   journeyContainer.appendChild(buttonContainer);
 
   return journeyContainer; 
  }

  generatePostCardPage() {
    // Criar o container principal
    const postcardContainer = document.createElement("div");
    postcardContainer.classList.add("journey-container");
  
    // Criar o título principal
    const title = document.createElement("h2");
    title.innerHTML = `Por aqui é só!<br><small>Mas sua jornada ainda não terminou.</small>`;
    title.classList.add("journey-title");
  
    // Mensagem da cartela
    const message = document.createElement("p");
    message.classList.add("journey-description");
    message.innerHTML = this.clickGameValue.post_card_message_text;
  
    // Criar o botão final
    const button = document.createElement("a");
    button.classList.add("btn", "btn-light", "mt-3");
    button.textContent = this.clickGameValue.post_card_button_text;
    button.href = this.clickGameValue.post_card_site;
    button.target = "_blank";
    button.rel = "noopener noreferrer";
  
    // Botão de voltar (opcional, caso queira manter)
    const backButton = document.createElement("button");
    backButton.classList.add("btn", "btn-outline-light", "mt-3", "me-2");
    backButton.textContent = "Voltar";
    backButton.addEventListener("click", () => {
      postcardContainer.remove();
      this.backdropOff();
    });
  
    // Container dos botões
    const buttonContainer = document.createElement("div");
    buttonContainer.classList.add("journey-buttons", "mt-4");
    buttonContainer.appendChild(backButton);
    buttonContainer.appendChild(button);
  
    // Montar a página
    // postcardContainer.appendChild(title);
    postcardContainer.appendChild(message);
    postcardContainer.appendChild(buttonContainer);
  
    return postcardContainer;
  }
  

  saveClickGame() {
    const clickGamePaths = pages.map((item, index) => ({
      id: item.id, // Mantém os valores existentes
      sequence: index + 1 // Adiciona a sequência começando de 1
    }));

    // Dados definidos
    const userId = 1;
    const mediationId = 2;

    // Mapeia os dados para o formato que a controller Rails espera (nested attributes)
    const clickGamePathsAttributes = clickGamePaths.map(path => ({
      click_game_work_id: path.id,
      sequence: path.sequence
    }));

    // Monta o objeto de dados que será enviado
    const data = {
      user_click_game: {
        user_id: userId,
        mediation_id: mediationId,
        click_game_paths_attributes: clickGamePathsAttributes
      }
    };

    // Obtém o token CSRF a partir da meta tag (necessário para Rails)
    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    // Envia a requisição POST para a rota de criação (/user_click_games)
    fetch("/trilhas-percorridas", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        "Accept": "application/json"
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error("Erro na requisição: " + response.statusText);
      }
      return response.json();
    })
    .then(data => {
      window.location.href = `/trilhas-percorridas/${data.id}`
      // console.log("Dados enviados com sucesso!", data);
      // Aqui você pode atualizar a interface ou redirecionar o usuário, conforme necessário
    })
    .catch(error => {
      console.error("Erro ao enviar os dados:", error);
    });



  }
  
  

  
  newSliderImage(imageUrl, alt) {
    const slide = document.createElement('li');
    slide.classList.add('splide__slide');

    // Criar um container para a imagem com proporção 16:9
    const imageContainer = document.createElement('div');
    imageContainer.style.position = "relative";
    imageContainer.style.width = "100%";
    imageContainer.style.maxHeight = "400px"; // Altura máxima para PC
    imageContainer.style.aspectRatio = "16 / 9"; // Mantém proporção
    imageContainer.style.overflow = "hidden";
    imageContainer.style.display = "flex";
    imageContainer.style.alignItems = "center";
    imageContainer.style.justifyContent = "center";

    // Criar um container para o spinner principal
    const loaderContainer = document.createElement('div');
    loaderContainer.style.display = "flex";
    loaderContainer.style.alignItems = "center";
    loaderContainer.style.justifyContent = "center";
    loaderContainer.style.width = "100%";
    loaderContainer.style.height = "100%";
    loaderContainer.style.position = "absolute";
    loaderContainer.style.backgroundColor = "#f0f0f0";

    imageContainer.appendChild(loaderContainer);
    slide.appendChild(imageContainer);

    // Criar um spinner menor para o thumbnail
    const thumbnailSpinnerContainer = document.createElement('div');
    thumbnailSpinnerContainer.style.position = "absolute";
    thumbnailSpinnerContainer.style.bottom = "10px";
    thumbnailSpinnerContainer.style.right = "10px";
    thumbnailSpinnerContainer.style.width = "15px";
    thumbnailSpinnerContainer.style.height = "15px";
    thumbnailSpinnerContainer.style.display = "flex";
    thumbnailSpinnerContainer.style.alignItems = "center";
    thumbnailSpinnerContainer.style.justifyContent = "center";
    thumbnailSpinnerContainer.style.backgroundColor = "rgba(255, 255, 255, 0.7)";
    thumbnailSpinnerContainer.style.borderRadius = "50%";

    slide.appendChild(thumbnailSpinnerContainer);

    // Configuração do Spinner principal
    const spinnerOptions = {
        lines: 12,
        length: 10,
        width: 4,
        radius: 15,
        scale: 1,
        corners: 1,
        speed: 1.5,
        rotate: 0,
        animation: "spinner-line-fade-default",
        color: "#333",
        fadeColor: "transparent",
        top: "50%",
        left: "50%",
        position: "absolute",
    };

    // Criar e iniciar o spinner principal
    const spinner = new Spinner(spinnerOptions).spin(loaderContainer);

    // Configuração do Spinner menor para o thumbnail
    const thumbnailSpinnerOptions = {
        lines: 6,
        length: 3,
        width: 1.5,
        radius: 3,
        scale: 0.3,
        corners: 1,
        speed: 1.5,
        rotate: 0,
        animation: "spinner-line-fade-default",
        color: "#333",
        fadeColor: "transparent",
    };

    // Criar e iniciar o spinner menor
    const thumbnailSpinner = new Spinner(thumbnailSpinnerOptions).spin(thumbnailSpinnerContainer);

    // Criar a imagem, mas mantê-la oculta inicialmente
    let sliderImage = document.createElement('img');
    sliderImage.src = imageUrl;
    sliderImage.alt = alt;
    sliderImage.style.maxWidth = "100%";
    sliderImage.style.maxHeight = "100%";
    sliderImage.style.objectFit = "contain"; // Garante que a imagem fique dentro sem cortes
    sliderImage.style.display = "none";

    // Quando a imagem carregar, substituir os spinners pelo conteúdo real
    sliderImage.onload = function () {
        spinner.stop(); // Para o spinner principal
        thumbnailSpinner.stop(); // Para o spinner do thumbnail
        loaderContainer.remove(); // Remove o container do loader principal
        thumbnailSpinnerContainer.remove(); // Remove o spinner do thumbnail
        sliderImage.style.display = "block"; // Exibe a imagem carregada
    };

    imageContainer.appendChild(sliderImage);
    return slide;
}


  
  
  

  newSliderTitle(page) {
    const slide = document.createElement( 'li' );
    slide.classList.add( 'splide__slide' );

    let sliderImage = document.createElement('img'); 
    sliderImage.src = imageUrl;
    sliderImage.alt = alt;
    sliderImage.style.width = '100%'; // Ajusta a largura
    sliderImage.style.height = 'auto'; // Ajusta a altura
    
    slide.appendChild(sliderImage);
    return slide;
  }

}
